{
  "lang": "en",
  "theme": "agroconnect",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "autostart",
    "cogs",
    "custom-radios",
    "end-tools",
    "headings",
    "history",
    "iconset",
    "legacy",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "metadata-change-navtext",
    "metadata-scoring",
    "metaprogress",
    "noscript",
    "questionlabelgroup-ng"
  ],
  "arbitrary": {
    "core": {
      "scrollToSelectedGroup": false
    },
    "noscript": {
      "linkstext": "This app requires JavaScript, but you can run it without by following the link below. We cannot guarantee a satisfactory user experience.",
      "links": [
        {
          "url": "open?modelname=agroconnect",
          "description": "AgroConnect"
        }
      ]
    },
    "legacy": {
      "notice": "<h1>Sorry :(</h1>This web app only runs on modern browsers.<br/>Supported browsers: <ul><li>Last (3) versions of Chrome<li>Firefox, current ESR (78.15.0esr) or higher,<li>Chromium-based Edge (from version 80)<li>Safari version 13.1 on OSX</ul><br>Internet Explorer and older Microsoft Edge (up to and incl. version 18) are <strong>not</strong> supported.<br>And JavaScript is required for the full, intended experience."
    }
  },
  "template": {
    "title": "AgroConnect",
    "seo": {
      "description": "",
      "canonical": "https://www.agroconnect.nl/"
    },
    "logo-link": "https://www.agroconnect.nl/",
    "restart-link": "https://agrifood-cybersecurity-selfassessment.com/",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "open-sans-v20"
  ]
}
